import * as Styles from './dropdown.styles';

export interface DropdownProps {
  list: {
    title: string;
    subtitle: string;
    value: string;
    rightChild?: string;
    isDisabled?: boolean;
  }[];
  onSelect: (value: any) => void;
  placeholderText: string;
  positionX?: number;
  positionY?: number;
  defaultOption?: any;
  value?: string;
  isValid?: boolean;
}

export function Dropdown({
  list,
  placeholderText,
  positionX = -145,
  positionY = 5,
  onSelect,
  defaultOption = null,
  value,
  isValid = true,
}: DropdownProps) {
  return (
    <Styles.Dropdown
      isValid={isValid}
      value={value}
      onSelect={(value, option) => {
        onSelect(option.value);
      }}
      dropdownMatchSelectWidth={false}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      dropdownStyle={Styles.dropdownStyles}
      dropdownAlign={{ offset: [positionX, positionY] }}
      placeholder={placeholderText}
      optionLabelProp="label"
      defaultValue={defaultOption}
    >
      {list?.map((item, index) => {
        return (
          <Styles.Item
            className="styledItem"
            value={item.value}
            label={item.title}
            disabled={item.isDisabled}
            key={index}
          >
            <Styles.Flex>
              <Styles.Title role={'heading'}>{item.title}</Styles.Title>
              {item?.rightChild && (
                <Styles.RightChild role={'heading'}>
                  {item?.rightChild}
                </Styles.RightChild>
              )}
            </Styles.Flex>
            <Styles.Subtitle role={'definition'}>
              {item.subtitle}
            </Styles.Subtitle>
          </Styles.Item>
        );
      })}
    </Styles.Dropdown>
  );
}

export default Dropdown;
